/**
 * Minting a quote for the promo-code step. A code can only be placed once the quote's packages
 * are known, so the wizard mints on reaching the step and again when an answer changes them.
 */

/** The country the quote is for, which savequote needs alongside the earlier answers. */
export const quoteCountry = (values: any) => {
  const location = ((values && values.selectedLocationLabel) || '').toLowerCase();

  if (location === 'non-uk eu') {
    return values.selectedEUCountry && values.selectedEUCountry.value;
  }

  if (location === 'other') {
    return values.selectedOtherCountry && values.selectedOtherCountry.value;
  }

  return values.unitedKingdom && values.unitedKingdom[0] && values.unitedKingdom[0].id;
};

/**
 * The four savequote answers the minted packages depend on; a change to any makes them stale.
 * A VAT number changes what is charged, not which packages are held. Empty while one is missing.
 */
export const quoteAnswersKey = (values: any): string => {
  if (!values) {
    return '';
  }

  const subjects = values.selectedSubject || [];
  const country = quoteCountry(values);

  if (!values.selectedPackage || subjects.length === 0 || !values.pupilsOnRoll || !country) {
    return '';
  }

  // Sorted: the order subjects were picked in is not a different basket.
  const sortedSubjects = [...subjects].sort((a: number, b: number) => a - b);

  return JSON.stringify([values.selectedPackage, sortedSubjects, values.pupilsOnRoll, country]);
};
